import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { formatItemDate, formatItemDateForSentenceStart } from '@/Utils/LocalizedDateFormat';
import { CollectionSort } from '@standardnotes/snjs';
import { c } from 'ttag';
const ListItemMetadata = ({ item, hideDate, sortBy }) => {
    const showModifiedDate = sortBy === CollectionSort.UpdatedAt;
    const date = showModifiedDate ? item.userModifiedDate : item.created_at;
    const formattedDate = date && (showModifiedDate ? formatItemDate(date) : formatItemDateForSentenceStart(date));
    if (hideDate && !item.protected) {
        return null;
    }
    return (_jsxs("div", { className: "leading-1.4 mt-1 text-sm opacity-50 lg:text-xs", children: [item.protected && (_jsxs("span", { children: [c('B3.Notes.NoteList.Label').t `Protected`, hideDate ? '' : ' • '] })), !hideDate && showModifiedDate && (_jsxs("span", { children: [c('B3.Notes.NoteList.Label').t `Modified`, " ", formattedDate || c('B3.Notes.NoteList.Label').t `Now`] })), !hideDate && !showModifiedDate && _jsx("span", { children: formattedDate || c('B3.Notes.NoteList.Label').t `Now` })] }));
};
export default ListItemMetadata;
